import { HttpError } from 'react-admin';
import { PATIENT_DELETE_BLOCKED_MESSAGE } from '../constants';

/**
 * Бэкенд: PatientCannotBeDeletedException, PatientHardDeleteForbiddenException, PatientDeleteException
 * — все отдают { message: string } с текстом на русском.
 */
export const resolveDeletePatientProfileError = (error: unknown): string => {
  if (error instanceof HttpError) {
    const message = error.body?.message;

    if (message) {
      return String(message);
    }

    if (error.status === 400) {
      return PATIENT_DELETE_BLOCKED_MESSAGE;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return 'Не удалось удалить профиль';
};
